import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AdminService {
    controlActive: WritableSignal<boolean> = signal(false);
    controlledUid: WritableSignal<string> = signal('');
    loadingControlledUid: WritableSignal<boolean> = signal(false);
}
